export { ComponentLoader } from './component-loader.class';
export { ComponentLoaderFactory } from './component-loader.factory';
export { ContentRef } from './content-ref.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/ngx-bootstrap/component-loader/index.js
// module id = ../../../../ngx-bootstrap/component-loader/index.js
// module chunks = 4